(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (_) {
      return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
    }
  };

  const init = (bar) => {
    if (!bar || bar.dataset.ready === 'true' || !matchMedia('(max-width: 749px)').matches) return;

    const mainButton = document.querySelector('[id^="ProductSubmitButton-"]');
    const stickyInput = bar.querySelector('[data-smp-sticky-variant]');
    const variantsNode = bar.querySelector('[data-smp-sticky-variants]');
    const price = bar.querySelector('[data-smp-sticky-price]');
    const button = bar.querySelector('[data-smp-sticky-button]');
    const label = button?.querySelector('span');
    if (!mainButton || !stickyInput || !variantsNode || !button || !label) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }
    bar.dataset.ready = 'true';

    const applyVariant = (variantId) => {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;
      stickyInput.value = variant.id;
      price.textContent = money(variant.price);
      button.disabled = !variant.available;
      label.textContent = variant.available
        ? window.variantStrings?.addToCart || 'Aan winkelwagen toevoegen'
        : window.variantStrings?.soldOut || 'Uitverkocht';
    };

    const syncFromMainForm = () => {
      const input = document.querySelector('product-info input.product-variant-id[name="id"]');
      if (input?.value) applyVariant(input.value);
    };

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
    }, { threshold: 0 });
    observer.observe(mainButton);

    const onFormChange = (event) => {
      if (event.target.closest('product-info')) queueMicrotask(syncFromMainForm);
    };
    document.addEventListener('change', onFormChange);

    let unsubscribeVariant;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.variant?.id) applyVariant(data.variant.id);
      });
    }

    const cleanup = () => {
      observer.disconnect();
      document.removeEventListener('change', onFormChange);
      unsubscribeVariant?.();
    };
    bar._smpCleanup = cleanup;
    syncFromMainForm();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-smp-sticky-cart]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-smp-sticky-cart]').forEach((bar) => bar._smpCleanup?.());
  });
})();
